System.amdDefine('jquery', [], function factory() {
  return window.jQuery;
});
